const url = {
    // Choisir selon le backend Laravel/Reverb utilisé, pas selon l'adresse de Vue.
    // Même avec Vue sur localhost:8080, garder SERVEUR si l'API reste distante.
    
    // === SERVEUR HTTPS (configuration actuellement active) ===
    root: "https://api.petitservice.fr/",
    api: "https://api.petitservice.fr/api/",
    rootAPI: 'api.petitservice.fr', // Hôte uniquement, sans https:// ni chemin.
    reverb: {
        wsPort: 6001,
        wssPort: 443, // Connexion sécurisée via le proxy HTTPS du serveur.
        forceTLS: true
    }, 
/*
    // === LOCAL HTTP ===
    // Pour utiliser l'API et le chat en local :
    // 1. Commenter tout le bloc SERVEUR ci-dessus (de root à la fin de reverb).
    // 2. Décommenter le bloc LOCAL ci-dessous et lancer Reverb sur le port 6001.
    // 3. Recompiler le frontend avant un déploiement si ces valeurs changent.
    root: "http://legalis/",
    api: "http://legalis/api/",
    rootAPI: 'legalis',
    reverb: {
        wsPort: 6001,  // Port du processus Reverb local.
        wssPort: 6001, // Non utilisé tant que le frontend reste en HTTP.
     forceTLS: false
    }, 
 */   
    // Doit correspondre à REVERB_APP_KEY dans le .env du backend choisi.
    reverbAPIkey: '3i52p2d7z7evqom3nibr'
}

export default url;
